'use client';

import type React from 'react';
import Image from 'next/image';

import { urlFor } from '@skybeam/shared-sanity';
import { cn } from '@skybeam/shared-utils/classnames/cn';
import { utils } from '../../../_components/utils';
import type {
  ResponsivePadding,
  ResponsiveValue,
  SanityImage,
} from '../../../_components/utils/types';

export type HeadingWithImageSectionProps = {
  backgroundColor?: string;
  containerPadding?: ResponsivePadding;
  contentMaxWidth?: ResponsiveValue;
  heading: string;
  image: SanityImage;
};

export const HeadingWithImageSection = ({
  backgroundColor,
  containerPadding,
  contentMaxWidth,
  heading,
  image,
}: HeadingWithImageSectionProps) => {
  const imageUrl = image?.asset && urlFor(image.asset).width(1836).url();
  const containerPaddingStyle =
    utils.responsiveUtils.getResponsivePaddingStyleTag(containerPadding);
  const contentMaxWidthStyle = utils.responsiveUtils.getResponsiveValueStyleTag(
    contentMaxWidth,
    'max-width',
  );
  const styleTags = [
    containerPaddingStyle.styleTag,
    contentMaxWidthStyle.styleTag,
  ].filter((tag): tag is React.ReactElement => tag !== null);
  const backgroundValue = backgroundColor?.trim();

  return (
    <>
      {styleTags}
      <div
        data-section="product-local-tv-business-few-clicks-section"
        className={cn(
          'tablet:py-16 laptop:py-20 desktop:py-24 flex w-full justify-center px-6 py-12',
          containerPaddingStyle.className,
        )}
        style={backgroundValue ? { background: backgroundValue } : undefined}
      >
        <div
          className={cn(
            'flex w-full flex-col items-center gap-y-9',
            contentMaxWidthStyle.className,
          )}
        >
          <h2 className="heading-marketing-2 text-center font-light">
            {heading}
          </h2>
          {imageUrl && (
            <Image
              src={imageUrl}
              alt={image.alt ?? 'Map Illustration'}
              width={1836}
              height={960}
            />
          )}
        </div>
      </div>
    </>
  );
};
